.facet {
  border-bottom: 1px solid #ddd;
}

/* Section header — "SHOP BY BRAND" with a +/- collapse indicator. */
.header {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.title {
  flex: 1;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #222;
}

.toggleIcon {
  margin-left: 8px;
  font-size: 20px;
  line-height: 1;
  color: #555;
}

/* Expandable menu. */
.menu {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition:
    max-height var(--ns-transition-duration) var(--ns-transition-easing),
    opacity var(--ns-transition-duration) var(--ns-transition-easing);
}

.facet.active .menu {
  max-height: var(--ns-facet-max-height);
  opacity: 1;
  overflow-y: auto;
}

/* Search box. */
.search {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 0 16px 12px;
}

.searchInput {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  font-family: inherit;
  font-size: 13px;
  color: #222;
  background: #fff;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
}

.searchButton {
  padding: 8px 14px;
  font-family: inherit;
  font-size: 13px;
  color: #222;
  background: #eaeaea;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
  cursor: pointer;
}

.searchButton:hover {
  background: #e0e0e0;
}

/* Checkbox list. */
.options {
  list-style: none;
  margin: 0;
  padding: 0 16px 12px;
}

.options li + li {
  margin-top: 12px;
}

/* Line-height matches the 16px checkmark so it aligns with the label text. */
.option {
  font-size: 14px;
  line-height: 16px;
  color: #222;
}

.optionSelected {
  font-weight: 700;
}

/* Mobile: no in-facet search, centered options with divider lines
   (padding on the li keeps the checkbox aligned with the label). */
@media (max-width: 767px) {
  .search {
    display: none;
  }

  .options li + li {
    margin-top: 0;
  }

  .options li {
    padding: 12px 0;
    border-top: 1px solid #e0e0e0;
    text-align: center;
  }

  .option {
    display: inline-block;
  }
}
